import React, { type CSSProperties } from "react";

import { connect } from "react-redux";

import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import { selector } from "../";
import * as action from "../../redux/actionCreators/guestlist";

interface IProps {
  guest: server.dto.LegacyGuest
}

interface IPropsFromState {
  guestlist: server.dto.LegacyGuestlist
  canEditOwnGuests: boolean
  canEditAllGuests: boolean
}

interface IDispatch {
  showGuestAddModal: (entry?: server.dto.LegacyGuest) => void
  removeEntry: (entryId: number) => any
  refreshGuestlist: (showId: number) => void
}

const mapStateToProps = (state): IPropsFromState => ({
  canEditAllGuests: selector.canEditAllGuests(state),
  canEditOwnGuests: selector.canEditOwnGuests(state),
  guestlist: selector.getGuestlist(state)
});

const mapDispatchToProps = (dispatch): IDispatch => ({
  refreshGuestlist: (showId: number) => dispatch(action.fetchGuestlist(showId)),
  removeEntry: (entryId: number) => dispatch(action.removeGuest(entryId)),
  showGuestAddModal: (entry?: server.dto.LegacyGuest) => dispatch(action.showAddGuestModal(entry))
});

class GuestAccordionRow extends React.Component<IProps & IPropsFromState & IDispatch> {
  public render(): JSX.Element {
    const { guest } = this.props;
    const visibilityCss = this.canSeeEditOption() ? {} : { visibility: "hidden" } satisfies CSSProperties;

    return (
      <div className="flex padding">
        <div style={{ width: 200 }}>
          <div>{guest.firstName} {guest.lastName} {this.formatBringsGuests(guest.bringsGuests)}</div>
        </div>
        <div className="" style={{ flex: 1 }}>
          <div className="s1_gray">{guest.email}</div>
          <div className="s1_gray">{guest.phone}</div>
          <div className="s1_gray">{guest.passport}</div>
        </div>
        <div className="" style={{ flex: 1 }}>
          <div className="flex gap">
            <div>
              <img className="avatar" src={guest.addedByUser.avatarUrl} />
            </div>

            <div className="grow1 margin-top-mini">
              {guest.addedByUser.fullName}
              <div className="text-sublabel">{guest.localFormattedTime}</div>
            </div>
          </div>
        </div>
        <PhosphorTrashButton
          layout="in-square"
          onClick={this.onDeleteClick}
          style={visibilityCss}
        />
        <PhosphorPencilButton
          layout="in-square"
          onClick={this.onEntryModifyClick}
          style={visibilityCss}
        />
      </div>
    );
  }

  private readonly canSeeEditOption = (): boolean => this.props.canEditAllGuests ||
    (this.props.canEditOwnGuests && this.props.guest.addedByUser.userId === site.currentUser.userId);

  private readonly onDeleteClick = () => {
    const { guest, removeEntry, guestlist, refreshGuestlist } = this.props;
    removeEntry(guest.guestId)
      .then(() => { refreshGuestlist(guestlist.showId); });
  };

  private readonly onEntryModifyClick = () => {
    this.props.showGuestAddModal(this.props.guest);
  };

  private formatBringsGuests(bringsGuests: number): string {
    return bringsGuests > 0 ? ("+" + bringsGuests) : "";
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestAccordionRow);
